import { render, staticRenderFns } from "./EmployeeRoster.vue?vue&type=template&id=21f339be&scoped=true&"
import script from "./EmployeeRoster.vue?vue&type=script&lang=js&"
export * from "./EmployeeRoster.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeRoster.vue?vue&type=style&index=0&id=21f339be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f339be",
  null
  
)

export default component.exports